export { default as AngleLeft } from './AngleLeft';
export { default as ArrowDown } from './ArrowDown';
export { default as VS } from './VS';
export { default as X } from './X';
